import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-testimonials7',
  templateUrl: './section-testimonials7.component.html',
  styleUrls: ['./section-testimonials7.component.css']
})
export class SectionTestimonials7Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
